import React from "react";
import LegalLayout, { Section } from "../components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="プライバシーポリシー"
      description="TMS株式会社（AdSche）が提供するサービスにおける個人情報の取扱い方針です。"
    >
      <Section>
        <h2>第1条（個人情報の定義）</h2>
        <p>
          本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法に定義される「個人情報」を指し、特定の個人を識別できる情報（氏名、メールアドレス、住所、電話番号、広告アカウントID等）を含みます。
        </p>
      </Section>

      <Section>
        <h2>第2条（個人情報の収集方法）</h2>
        <p>
          当社は、ユーザーが本サービスを利用登録する際に入力した情報や、利用中に送信される情報（Amazon広告API経由の広告アカウント情報など）を収集します。
        </p>
      </Section>

      <Section>
        <h2>第3条（利用目的）</h2>
        <ul>
          <li>本サービスの提供・運営のため</li>
          <li>ユーザーからのお問い合わせ対応</li>
          <li>メンテナンス・重要なお知らせなど必要に応じた連絡</li>
          <li>利用規約に違反する行為への対応</li>
          <li>サービス品質向上・機能改善のための分析</li>
          <li>新サービス・キャンペーンの案内（ユーザー承諾がある場合）</li>
        </ul>
      </Section>

      <Section>
        <h2>第4条（第三者提供）</h2>
        <p>
          当社は、法令に基づく場合を除き、ユーザーの同意なく第三者に個人情報を提供することはありません。
        </p>
      </Section>

      <Section>
        <h2>第5条（外部サービス利用）</h2>
        <p>
          当社は、本サービスの運営にあたり以下の外部サービスを利用することがあります。Stripe（決済処理）、Amazon Ads API（広告運用データ取得）など。
        </p>
      </Section>

      <Section>
        <h2>第6条（安全管理）</h2>
        <p>
          当社は、個人情報の漏えい・滅失・毀損を防止するため、適切なセキュリティ対策を実施します。
        </p>
      </Section>

      <Section>
        <h2>第7条（開示・訂正・削除）</h2>
        <p>
          ユーザーは、当社が保有する自己の個人情報について、開示・訂正・利用停止・削除を求めることができます。請求先は下記お問い合わせ窓口までご連絡ください。
        </p>
      </Section>

      <Section>
        <h2>第8条（お問い合わせ窓口）</h2>
        <p>
          住所：埼玉県さいたま市大宮区桜木町2-3-7F<br />
          事業者名：TMS株式会社<br />
          運営統括責任者：乙坂 努<br />
          メールアドレス：adsche@tms-ec.co.jp
        </p>
      </Section>

      <Section>
        <h2>第9条（改定）</h2>
        <p>
          本ポリシーの内容は、法令変更や運営方針の変更に応じて、事前の告知なく改定する場合があります。改定後は本ページに掲載した時点で効力を生じます。
        </p>
      </Section>
    </LegalLayout>
  );
}